__turbopack_context__.v({
  "controls": "GamepadModal-module__qeaOia__controls",
  "lottie": "GamepadModal-module__qeaOia__lottie",
  "main": "GamepadModal-module__qeaOia__main",
  "text": "GamepadModal-module__qeaOia__text",
});
